// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KZq1ivK5nTVyJ5 {
  margin: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var offeringLozenge = `KZq1ivK5nTVyJ5`;
export default ___CSS_LOADER_EXPORT___;
